export default function DataScience() {
    return (
        <div className={"blog-body"}>
            <h2>Data Science</h2>
            <p>
                Data science is a field of study that analyzes the data collected in various ways and draws
                conclusions from them, and makes predictions for the future by examining the patterns.
                It is not possible to distinguish the branches of data science completely from each other,
                different opinions exists, for example Longbing Cao defines data science as "data science
                = statistics + informatics + computing + communication + sociology + management |
                data + environment + thinking" (Cao, 2017).
            </p>
            <p>
                Business intelligence department uses the data organized by data engineers and analyze
                it to gain business insights. Data visualization is a critical skill in this work field,
                business
                intelligence analysts visualizes the data, measures performance indicators and creates
                reports. </p>
            <p>
                To make predictions about future, data scientist use statistical approaches like
            </p>

            <ul>
                <li><b>Regression:</b> It is one of the modeling methods used to measure the relationship
                    between variables. Ranges from simple line fitting to complex structures like forest
                    models. Used with numerical data.
                </li>
                <li><b>Classification:</b> For grouping similar objects into clusters. There are many types
                    of clustering methods (Xu & Tian, 2015), few of them are centroid-based clustering,
                    distribution-based clustering, density-based clustering and hierarchical clustering.
                    Used with categorical data.
                </li>
                <li><b>Factor Analysis:</b> Factor analysis is process of explaining observed variables'
                    variability
                    with common factors (unobserved variables).
                </li>
            </ul>
</div>
)
    ;
}